// extracted by mini-css-extract-plugin
export default {"header":"Profile-module__header--7WCHb","editLink":"Profile-module__editLink--Q4HzC"};